import { useState } from "react";
import InventoryClosingForm from "./InventoryClosingForm";
import InventoryClosingList from "./InventoryClosingList";

const InventoryClosing = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <InventoryClosingForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <InventoryClosingList
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default InventoryClosing;
